import { getRegisteredVizTypes } from '@/lib/customVizRegistry';

/**
 * Built-in visual types shown in the visual-card "type" picker.
 * Plugin-registered viz types are appended at the end via `getMergedVizTypeOptions()`.
 */
export const BUILT_IN_VIZ_TYPES = [
  { value: 'table', label: 'Table' },
  { value: 'bar_chart', label: 'Bar' },
  { value: 'line_chart', label: 'Line' },
  { value: 'area_chart', label: 'Area' },
  { value: 'pie_chart', label: 'Pie' },
  { value: 'combo', label: 'Combo' },
  { value: 'scatter', label: 'Scatter' },
  { value: 'gauge', label: 'Gauge' },
  { value: 'funnel', label: 'Funnel' },
  { value: 'waterfall', label: 'Waterfall' },
  { value: 'treemap', label: 'Treemap' },
  { value: 'wordcloud', label: 'Word Cloud' },
  { value: 'heatmap', label: 'Heatmap' },
  { value: 'geo_map', label: 'Geo Map' },
  { value: 'pivot', label: 'Pivot' },
  { value: 'loss_triangle', label: 'Triangle' },
  { value: 'ai_text', label: 'AI Text' },
  { value: 'kpi', label: 'KPI Card' },
  { value: 'image', label: 'Image' },
  { value: 'rich_text', label: 'Text' },
  { value: 'shape', label: 'Shape' },
];

export function getMergedVizTypeOptions() {
  const custom = getRegisteredVizTypes().map(reg => ({ value: reg.type, label: reg.label || reg.type }));
  return [...BUILT_IN_VIZ_TYPES, ...custom];
}
